import * as React from 'react';
import Text from '../Text';
import './style.scss';
import classNames from 'classnames';
import { ChangeEvent, useCallback } from 'react';

interface Props {
  name: string;
  value: string;
  placeholder?: string;
  title: string;
  className?: string;
  multiline?: boolean;
  error: string;
  onValueChange?: (value: string) => void;
}

const Input: React.SFC<Props> = ({
  name,
  value,
  error,
  placeholder,
  title,
  className,
  multiline,
  onValueChange,
}) => {
  const [isFocused, setIsFocused] = React.useState(false);

  const onFocus = useCallback(() => setIsFocused(true), []);
  const onBlur = useCallback(() => setIsFocused(false), []);

  const onChange = useCallback<
    (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void
  >((e) => onValueChange?.(e.target.value), [onValueChange]);

  return (
    <div className={classNames('input-legacy', className)}>
      <label htmlFor={name}>
        <Text
          type="button"
          color="dark"
          className={classNames('input-legacy__label', {
            'input__label--focused': value.length > 0 || isFocused,
            'input__label--error': error !== '',
          })}
        >
          {error !== '' ? error : title}
        </Text>
      </label>
      {multiline ? (
        <textarea
          // prevents grammarly from working
          data-gramm="false"
          placeholder={placeholder}
          name={name}
          id={name}
          value={value}
          required
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
          className={classNames({ 'input--error': error !== '' })}
        />
      ) : (
        <input
          // prevents grammarly from working
          data-gramm="false"
          placeholder={placeholder}
          type="text"
          name={name}
          id={name}
          value={value}
          required
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
          className={classNames({ 'input--error': error !== '' })}
        />
      )}
    </div>
  );
};

export default Input;
